import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../Navbar'
import PageTitle from '../pagetitle'
import BookingForm from '../BookingForm'
import Footer from '../footer'
import Scrollbar from '../scrollbar'
import freeDemoImg from '../../images/service/service/Free Demo Class.webp'
import demoProcessImg from '../../images/service/service-sub-pages/Free Demo Class.jpg'
import banner6 from '../../images/banners/6.webp'
import './style.css'

const FreeDemo = () => {
    const ClickHandler = (e) => {
        const hash = e.currentTarget.hash;
        if (hash === '#booking-form') {
            e.preventDefault();
            const element = document.getElementById('booking-form');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.scrollTo(10, 0);
        }
    }

    return (
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Free Demo Class'} pagesub={'Service'} backgroundImage={banner6} hideText={true}/>
            <section className="service-single-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8 col-md-12 col-12">
                            <div className="service-single-content">
                                <div className="service-single-img">
                                    <img src={freeDemoImg} alt="Free Demo Class"/>
                                </div>
                                <h2 className="service-title">Free Demo Class</h2>
                                <div className="service-description">
                                    <p>We believe that choosing the right Quran teacher is an important decision. That's why we offer a complimentary trial lesson for all new students. Our free demo class gives you the opportunity to experience our teaching methodology, meet our qualified tutors, and determine if our approach is the right fit for your learning goals – all with no obligation to enroll.</p>
                                </div>
                                
                                <div className="service-single-inner">
                                    <span><img src={demoProcessImg} alt="Demo Class Process"/></span>
                                    <div className="service-single-tb-text">
                                        <h3 className="service-section-title"><i className="fi flaticon-mortarboard"></i> Try Before You Enroll</h3>
                                        <p>Our free demo session is designed to:</p>
                                        <ul className="service-features-list">
                                            <li>Introduce you to our teaching style and online learning platform</li>
                                            <li>Allow our tutor to assess your current level and learning needs</li>
                                            <li>Give you a chance to ask questions about our courses and methodology</li>
                                            <li>Help you make an informed decision before committing to regular classes</li>
                                            <li>Demonstrate the quality and professionalism of our tutors</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-classroom"></i> What to Expect in Your Demo Class</h3>
                                    <div className="service-section-content">
                                        <p>Your free 30-minute trial lesson will include:</p>
                                        <ul className="service-features-list">
                                            <li>A friendly introduction and discussion of your learning goals</li>
                                            <li>A brief assessment of your current knowledge level (if applicable)</li>
                                            <li>Sample teaching of content relevant to your intended course</li>
                                            <li>Demonstration of our interactive online tools and resources</li>
                                            <li>Time for questions and discussion about course options</li>
                                            <li>Information about scheduling and fees if you decide to continue</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-calendar"></i> Easy Booking Process</h3>
                                    <div className="service-section-content">
                                        <p>Scheduling your free trial lesson is simple:</p>
                                        <ol className="service-process-list">
                                            <li>Contact us through our website form, WhatsApp, or phone</li>
                                            <li>Provide basic information about the student (age, previous Quranic study if any)</li>
                                            <li>Indicate which course you're interested in exploring</li>
                                            <li>Let us know your preferred days and times for the demo</li>
                                            <li>We'll match you with an appropriate tutor and confirm your appointment</li>
                                            <li>You'll receive a confirmation email with the session link and setup instructions</li>
                                        </ol>
                                    </div>
                                </div>
                                
                                <div className="service-section">
                                    <h3 className="service-section-title"><i className="fi flaticon-support"></i> After Your Demo Class</h3>
                                    <div className="service-section-content">
                                        <p>Following your free trial:</p>
                                        <ul className="service-features-list">
                                            <li>There is absolutely no obligation to sign up</li>
                                            <li>We'll follow up once to answer any additional questions</li>
                                            <li>If you decide to enroll, we'll help you set up a regular schedule</li>
                                            <li>You can request a different tutor if you prefer a different teaching style</li>
                                            <li>We offer enrollment guidance to help you choose the best course and format</li>
                                        </ul>
                                    </div>
                                </div>
                                
                                <div className="service-conclusion">
                                    <p>Our free demo class is a risk-free way to experience the quality of education we provide at Dar-ul-Quran Academy. We're confident that you'll appreciate our structured approach, qualified teachers, and supportive learning environment. Book your complimentary session today and take the first step on your Quranic learning journey.</p>
                                </div>
                                
                                <div className="btns text-center mt-5">
                                    <Link onClick={ClickHandler} to="/home#booking-form" className="theme-btn">Book Your Free Demo Class Now</Link>
                                </div>
                            </div>
                            
                            <div className="prv-nx">
                                <div className="pre-btn"><Link onClick={ClickHandler} to="/class-options">Previous: Class Options</Link></div>
                                <div className="nex-btn"><Link onClick={ClickHandler} to="/assessments">Next: Assessments & Certification</Link></div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-4 col-md-12 col-12">
                            <div className="service-sidebar">
                                <div className="widget service-list-widget">
                                    <h3>All Services</h3>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida (Beginner Quran Reading)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed">Tajweed (Quran Recitation Rules)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement (Advanced)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/hifz">Hifz (Quran Memorisation)</Link></li>
                                        <li><Link onClick={ClickHandler} to="/class-options">Class Options</Link></li>
                                        <li className="current"><Link to="/free-demo">Free Demo Class</Link></li>
                                        <li><Link onClick={ClickHandler} to="/assessments">Assessments & Certification</Link></li>
                                    </ul>
                                </div>
                                <div className="widget contact-widget">
                                    <div>
                                        <h4>Questions About Our Free Demo?</h4>
                                        <h2><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BookingForm/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
}

export default FreeDemo; 